// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"9ef96e5d","280":"9ecb1dcc","376":"f4b4d037","672":"c1ce3031","729":"3ecf63ae","816":"434d1f86"}[chunkId] + ".chunk.js";
};